/* assets/tr-kit-builder.js (moved out of sections/truerim-kit-builder.liquid 2026-10-22 so the browser caches it across the color pages). */
(function(){
  var SID = (document.currentScript && document.currentScript.getAttribute('data-sid')) || '';
  var root = document.getElementById('trkb-' + SID);
  if (!root || root.getAttribute('data-trkb-init')) return;
  var D;
  try { D = JSON.parse(root.querySelector('[data-trkb-data]').textContent); } catch (e) { return; }

  /* ---------- helpers ---------- */
  function str(x){ return typeof x === 'string' ? x : ''; }
  Object.keys(D.notes || {}).forEach(function(k){ D.notes[k] = str(D.notes[k]); });
  Object.keys(D.copy || {}).forEach(function(k){ if (typeof D.copy[k] !== 'boolean') D.copy[k] = str(D.copy[k]); });
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  /* every TrueRim aerosol is a 12 oz (340 g) net can (owner, 2026-10-04) */
  var AERO_SIZE = '12 oz (340 g) aerosol';
  function nice(t){ return String(t || '').replace(/\b2k\b/g, '2K').replace(/\b1k\b/g, '1K'); }
  function money(cents){
    var fmt = String(D.moneyFormat || '').replace(/<[^>]*>/g, '');
    var n = (Math.round(cents) / 100);
    function grp(x, d, th, dec){ var p = x.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.join(dec); }
    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, k){
      if (k === 'amount_no_decimals') return grp(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return grp(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return grp(n, 0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return grp(n, 2, "'", '.');
      if (k === 'amount_with_space_separator') return grp(n, 2, ' ', ',');
      if (k === 'amount_with_period_and_space_separator') return grp(n, 2, ' ', '.');
      if (k === 'amount_no_decimals_with_space_separator') return grp(n, 0, ' ', ',');
      return grp(n, 2, ',', '.');
    });
    return out === fmt ? '$' + grp(n, 2, ',', '.') : out;
  }
  function vol(title){
    var t = String(title || '').toLowerCase();
    if (/aerosol|spray ?can/.test(t)) return 0;
    if (/gallon/.test(t)) return 128;
    if (/quart/.test(t)) return 32;
    if (/pint/.test(t)) return 16;
    var m = t.match(/(\d+(?:\.\d+)?)\s*oz/); if (m) return parseFloat(m[1]);
    m = t.match(/(\d+(?:\.\d+)?)\s*(?:l\b|liter)/); if (m) return parseFloat(m[1]) * 33.814;
    return 0;
  }
  function P(role){ return (D.products && D.products[role]) || null; }
  function firstAvail(p){ if (!p) return null; for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) return p.variants[i]; } return null; }
  function findV(p, id){ if (!p) return null; for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].id === id) return p.variants[i]; } return null; }
  function paintV(id){ for (var i = 0; i < D.paint.variants.length; i++) { if (D.paint.variants[i].id === id) return D.paint.variants[i]; } return null; }
  function vLabel(v){ return String(v.title).replace(/\s*\/\s*Single$/i, ''); }
  function subFor(p, v){
    if (!p || !v || (p.variants.length === 1 && /^(default title|single)$/i.test(v.title))) return '';
    var l = vLabel(v); return p.title.toLowerCase().indexOf(l.toLowerCase()) > -1 ? '' : l;
  }
  function linRGB(hex){
    /* #rgb / #rgba / #rrggbb / #rrggbbaa, as the Liquid kb_hex_ok check and Pro-DIY accept; alpha is dropped */
    var h = String(hex || '').trim().replace(/^#/, '');
    if (/^[0-9a-f]{3,4}$/i.test(h)) h = h.replace(/./g, function(c){ return c + c; });
    var m = /^([0-9a-f]{6})(?:[0-9a-f]{2})?$/i.exec(h); if (!m) return null;
    var n = parseInt(m[1], 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255].map(function(x){ x /= 255; return x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4); });
  }
  function lum(hex){ var c = linRGB(hex); return c ? 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2] : 1; }
  /* Black primer only if luminance < 0.085 (CIE L* < ~35) AND linear red < 0.10 (sRGB red <= 89); reds and maroons get Grey (DuPont CA2052215C, Sherwin-Williams US7014466B2) */
  function isDark(hex){ var c = linRGB(hex); return !!c && lum(hex) < 0.085 && c[0] < 0.10; }
  var DARK = isDark(D.paint.hex);
  /* primer shade copy (owner 2026-10-28, as on the Pro-DIY Wheel Kit): with a swatch the kit says it picked SHADE and names it
     for hand builds; with no usable swatch it never claims a pick and gives the hand rule. Samples never reach this copy. */
  var HEX = !!linRGB(D.paint.hex), SHADE = DARK ? 'Black' : 'Grey';
  function shadeOf(v){ var t = v ? v.title : ''; return /black/i.test(t) ? 'Black' : /gr[ae]y/i.test(t) ? 'Grey' : ''; }
  /* only while the 1K primer is on: "picked automatically" only when its SHADE variant really was in stock to pick;
     otherwise the hand rule. The other shade picked by hand shows primerMismatch() in this line's place. */
  function primerPickNote(){
    if (S.primer.key !== 'primer_1') return '';
    if (!HEX) return D.copy.primerHandNote;
    var sv = shadeVariant(P('primer_1'));
    return sv && shadeOf(sv) === SHADE ? fill(D.copy.primerAutoNote, { shade: SHADE }) : D.copy.primerHandNote;
  }
  /* the other shade picked by hand: a neutral note, never a warning */
  function primerMismatch(){
    if (!HEX || S.primer.key === 'none' || !D.copy.primerMismatchNote) return '';
    var sh = shadeOf(findV(P(S.primer.key), S.primer.id)); return sh && sh !== SHADE ? fill(D.copy.primerMismatchNote, { shade: SHADE }) : '';
  }
  function primerColorOnly(){ return HEX ? fill(D.copy.primerColorOnlyNote, { shade: SHADE }) : D.copy.primerColorOnlyHand; }
  function shadeVariant(p){
    if (!p) return null;
    var want = DARK ? /black/i : /gr[ae]y/i;
    for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available && want.test(p.variants[i].title)) return p.variants[i]; }
    return firstAvail(p);
  }
  function sizeOf(v){ return D.paint.single ? 'Aerosol' : (v.size || v.title); }
  function paintOz(){ var v = paintV(S.paintId); return (v && !isSample()) ? vol(sizeOf(v)) : 0; }
  function isLiquid(){ return paintOz() > 0; }
  /* Color Samples (owner 2026-10-27, template level): ONE store product sells the spray-out card for every color. D.sample is
     its Standard or Special variant (picked in the Liquid: Special for candy and tri-coat / 2-stage colors); null when that
     product is missing or unavailable, and then there is no Sample tile at all. A sample is never a kit: no clear, primer,
     reducer, supplies, warnings, can notes or printed guide, and the Kit / Color only choice is locked while it is picked.
     S.smp only flags the pick: the paint size and every kit choice stay untouched, so going back restores them exactly. */
  var SMP = (D.sample && D.sample.id && D.sample.available && !D.paint.single) ? D.sample : null, SMP_CAP = 5;
  function isSample(){ return !!SMP && !!S.smp; }
  /* "Enter your color" (owner 2026-10-27): a sample of ANY color, not only the stocked ones. The form is the shared
     <tr-sample-request> (snippets/tr-sample-request.liquid, mode inline, custom only) rendered inside the root; this script keeps
     the one element and moves it into the Sample step's slot on every render, so typed values survive. It adds its own line
     (the sample product's Standard / Special variant with Make / Year / Model / Paint code / Color name + _sample_custom) and
     never reads or writes the kit state: S.smpSrc only says which half of the split is shown. */
  var smpEl = null;
  function smpCustom(){ return isSample() && !!smpEl && S.smpSrc === 'custom'; }
  /* cap: a soft per-line limit (the sample's 5) on top of the stock cap */
  function capFor(v){ var m = (v && v.max != null) ? v.max : 99; return (v && v.cap != null) ? Math.min(v.cap, m) : m; }
  /* the sample line's properties: Color and Paint code show in the cart and on the order; _sample_of (hidden) names the color */
  function sampleProps(){
    var o = { 'Color': D.paint.name + (D.paint.make ? ' \u2014 ' + D.paint.make : '') };
    if (D.paint.code) o['Paint code'] = D.paint.code;
    if (D.paint.handle) o['_sample_of'] = D.paint.handle;
    return o;
  }
  function fill(s, map){ return String(s || '').replace(/\[(\w+)\]/g, function(m, k){ return map[k] != null ? map[k] : m; }); }
  /* size-aware copy: the reducer is only ever named on Pint / Quart / Gallon; aerosol copy never mentions it */
  function lq(base, liquid){ return isLiquid() && D.copy[liquid] ? D.copy[liquid] : noRed(D.copy[base]); }
  /* safety net for theme-editor text: on aerosol, any sentence that names the reducer is dropped */
  function noRed(t){ if (isLiquid() || !/reduc/i.test(t || '')) return t; return (String(t).match(/[^.!?]+[.!?]*\s*/g) || []).filter(function(x){ return !/reduc/i.test(x); }).join('').trim(); }
  function guideOn(){ return !!(D.copy.showPrintedGuide && S.guide.on) && !isSample(); }

  /* ---------- state ---------- */
  var CLEARS = ['clear_1', 'clear_2', 'clear_3', 'clear_4', 'clear_gun', 'clear_vc100'];
  /* step index per line: 0 Color, 1 Prep & primer (reducer, primer, supplies), 2 Clear coat (clear, hardener), 3 Review */
  var STEP_PREP = 1, STEP_CLEAR = 2;
  var PRIMERS = ['primer_1', 'primer_2', 'primer_3'];
  var SUPPLIES = ['supply_1', 'supply_2', 'supply_3', 'supply_4', 'supply_5'];
  /* mode: 'kit' | 'color'. Color only filters kbLines(); it never touches reducer/clear/primer/supplies */
  var S = { step: 0, mode: 'kit', seen: [false, false, false, false], paintId: null, paintQty: 1,
    guide: { on: false }, guidePending: null, guideFail: false,
    /* lastAdd: the paint line of the last kit added here ({kit, id, key, guide, guided}); a printed guide asked for
       after that add is written onto this line with cart/change.js (same quantity, same _kit) */
    lastAdd: null, smp: false, smpQty: 1, smpSrc: 'this',
    /* on: in the Complete kit (pre-checked); colorOn: the Color only add-on (pre-unchecked). Both only ever count on liquid sizes */
    reducer: { on: true, colorOn: false, id: null, qty: 1, auto: true },
    /* auto: the qty follows the aerosol paint qty in the Complete kit (syncKitQty) until the shopper sets it by hand */
    clear: { key: 'none', id: null, qty: 1, picked: false, auto: true },
    primer: { key: 'none', id: null, qty: 1, auto: true },
    supplies: {}, notice: '', msg: '', msgType: '', busy: false };
  SUPPLIES.forEach(function(k){ var v = firstAvail(P(k)); S.supplies[k] = { on: false, id: v ? v.id : null, qty: 1 }; });

  /* reducer: 2 parts paint to 1 part reducer, so reducer oz needed = paint oz × qty × containers ÷ 2.
     Two-container pearls ship a Stage 1/2 and a Stage 2/2 container per size and each is reduced 2:1 (owner,
     2026-10-03). An undercoat on an undercoat_needed color is included in the order but is not counted here (unchanged math). */
  /* every paint stage ships in its own container and is reduced 2:1 (Stage 1/2 + Stage 2/2 colors, and colors with an included undercoat) */
  function stageCount(){ return (D.paint.twoContainers || D.paint.needsUndercoat) ? 2 : 1; }
  function reducerNeed(){ return paintOz() * S.paintQty * stageCount() / 2; }
  function reducerPick(){
    var p = P('reducer'); if (!p) return null;
    var need = reducerNeed();
    var opts = p.variants.filter(function(v){ return v.available && vol(v.title) > 0; }).sort(function(a, b){ return vol(a.title) - vol(b.title); });
    if (!opts.length) { var f = firstAvail(p); return f ? { id: f.id, qty: 1 } : null; }
    for (var i = 0; i < opts.length; i++) { if (vol(opts[i].title) >= need) return { id: opts[i].id, qty: 1 }; }
    var big = opts[opts.length - 1]; return { id: big.id, qty: Math.ceil(need / vol(big.title)) };
  }
  function reducerOn(){ return S.mode === 'color' ? S.reducer.colorOn : S.reducer.on; }
  function syncReducer(){
    if (!S.reducer.auto) return;
    var r = reducerPick(); S.reducer.id = r ? r.id : null; S.reducer.qty = r ? r.qty : 1;
  }
  /* Complete kit clear + primer per size (owner 2026-10-28). Only Aerosol scales:
     - Aerosol: 1 aerosol clear per color aerosol, and 2 primers per 3 color aerosols (3 cans of color and 2 primers cover a
       set of 4 wheels): primer = ceil(qty x 2 / 3), so 1->1, 2->2, 3->2, 4->3, 6->4. A 2-stage / undercoat color counts the
       units picked (each unit is a two-can set).
     - Pint: a fixed set-of-four-wheels kit whatever the pint qty: 3 aerosol clears + 2 aerosol primers, or one spray-gun
       clear (Speed Kit, or VC100 + VC102 1:1) at qty 1.
     - Quart / Gallon: spray-gun clears only, one Speed Kit (or VC100 + VC102) at qty 1, never scaled; primer 3.
     Like the reducer's auto flag: a line the shopper changed by hand stops following until the size changes. Caps (stock,
     VC100's hardener 1:1) always win. Color only and Sample only filter kbLines(); the reducer keeps its own 2:1 math. */
  var PINT_CLEARS = 3, PINT_PRIMERS = 2, BIG_PRIMERS = 3, AERO_CLEARS = CLEARS.slice(0, 4), GUN_CLEARS = CLEARS.slice(4);
  /* 'aero' | 'pint' (16 oz and under) | 'big' (Quart, Gallon) */
  function sizeClass(){ var oz = paintOz(); return !oz ? 'aero' : oz <= 16 ? 'pint' : 'big'; }
  function clearFor(q){ var c = sizeClass(); return isGunClear(S.clear.key) || c === 'big' ? 1 : c === 'pint' ? PINT_CLEARS : q; }
  function primerFor(q){ var c = sizeClass(); return c === 'big' ? BIG_PRIMERS : c === 'pint' ? PINT_PRIMERS : Math.ceil(q * 2 / 3); }
  function syncKitQty(){
    var q = Math.max(1, S.paintQty);
    if (S.clear.auto && S.clear.key !== 'none') S.clear.qty = Math.max(1, Math.min(clearFor(q), clearCap(findV(P(S.clear.key), S.clear.id))));
    if (S.primer.auto && S.primer.key !== 'none') S.primer.qty = Math.max(1, Math.min(primerFor(q), capFor(findV(P(S.primer.key), S.primer.id))));
  }
  /* display order: Aerosol and Pint lead with the SprayMax aerosols, then the gun clears (Speed Kit, then VC100 + VC102),
     tagged "needs a spray gun" on aerosol paint only. Quart / Gallon offer the gun clears only (no aerosol clears). */
  function clearOrder(){ return sizeClass() === 'big' ? GUN_CLEARS.slice() : AERO_CLEARS.concat(GUN_CLEARS); }
  function clearAllowed(k){ return clearOrder().indexOf(k) > -1; }
  /* the default: an aerosol clear on Aerosol (never a gun clear) and on Pint (a gun clear only if every aerosol is sold out);
     the Speed Kit on Quart / Gallon */
  function defaultOrder(){ var c = sizeClass(); return c === 'aero' ? AERO_CLEARS.slice() : clearOrder(); }
  function isGunClear(k){ return k === 'clear_gun' || k === 'clear_vc100'; }
  function hardenerV(){ return firstAvail(P('hardener')); }
  /* VC100 on its own is only offered while its VC102 hardener can ship with it */
  function clearAvail(k){ return !!firstAvail(P(k)) && (k !== 'clear_vc100' || !!hardenerV()); }
  function recommendedClear(){ var o = defaultOrder(); for (var i = 0; i < o.length; i++) { if (clearAvail(o[i])) return o[i]; } return null; }
  function applyClearDefault(){
    if (S.clear.picked) return;
    var order = defaultOrder(), pick = recommendedClear(); S.notice = '';
    if (!pick) { S.clear.key = 'none'; S.clear.id = null; return; }
    if (pick !== order[0] && P(order[0])) S.notice = nice(P(order[0]).title) + ' is sold out right now, so we picked ' + nice(P(pick).title) + '.';
    S.clear.key = pick; S.clear.id = firstAvail(P(pick)).id; S.clear.qty = 1;
  }
  /* VC100 qty is capped by its hardener's cap too, since the hardener line follows it 1:1 */
  /* a switched clear keeps the quantity it had (scaled or set by hand), within the new clear's cap */
  function clearKeep(q){ return Math.max(1, Math.min(q || 1, clearCap(findV(P(S.clear.key), S.clear.id)))); }
  function clearCap(v){ var c = capFor(v); if (S.clear.key === 'clear_vc100') c = Math.min(c, capFor(hardenerV())); return c; }
  function applyPrimerDefault(){
    for (var i = 0; i < PRIMERS.length; i++) { var v = shadeVariant(P(PRIMERS[i])); if (v) { S.primer.key = PRIMERS[i]; S.primer.id = v.id; S.primer.qty = 1; syncKitQty(); return; } }
    S.primer.key = 'none'; S.primer.id = null;
  }

  /* ---------- the single source for total AND payload ---------- */
  function line(role, step, p, v, qty){
    return { role: role, step: step, id: v.id, qty: qty, price: v.price, title: nice(p.title), sub: subFor(p, v), image: p.image, max: v.max };
  }
  function kbLines(){
    var L = [], pv = paintV(S.paintId);
    if (isSample()) {
      /* a sample is the one line (the sample product's variant), never a kit */
      L.push({ role: 'paint', step: 0, id: SMP.id, qty: S.smpQty, price: SMP.price, title: D.paint.name, sub: 'Sample' + (D.copy.sampleSub ? ' \u00b7 ' + D.copy.sampleSub : ''), image: D.paint.image, max: SMP.max, cap: SMP_CAP, fixed: true, props: sampleProps() });
      return L;
    }
    if (pv && pv.available) {
      var pl = { role: 'paint', step: 0, id: pv.id, qty: S.paintQty, price: pv.price, title: D.paint.name, sub: (D.paint.single || !isLiquid()) ? AERO_SIZE : sizeOf(pv), image: D.paint.image, max: pv.max, fixed: true };
      /* printed guide: a visible property on the paint line only; properties never change price */
      if (guideOn()) pl.props = { 'Printed guide': isLiquid() ? D.copy.guideGun : D.copy.guideAerosol };
      /* draft QA 2026-10-23: a 2-stage / undercoat color's Aerosol is two cans: say so on the cart line (drawer, cart, checkout) */
      if (!isLiquid() && stageCount() === 2) { pl.props = pl.props || {}; pl.props['Includes'] = '2 cans (' + (D.paint.twoContainers ? 'Stage 1 + Stage 2' : 'undercoat + color') + ')'; }
      L.push(pl);
    }
    /* reducer: liquid sizes only, never aerosol; kit mode uses S.reducer.on, Color only the add-on S.reducer.colorOn */
    if (isLiquid() && reducerOn() && S.reducer.id) { var rp = P('reducer'), rv = findV(rp, S.reducer.id); if (rv && rv.available) L.push(line('reducer', STEP_PREP, rp, rv, S.reducer.qty)); }
    if (S.mode === 'color') return L;
    if (S.primer.key !== 'none') { var pp = P(S.primer.key), ppv = findV(pp, S.primer.id); if (ppv && ppv.available) L.push(line('primer', STEP_PREP, pp, ppv, S.primer.qty)); }
    if (D.copy.showSupplies) SUPPLIES.forEach(function(k){ var s = S.supplies[k], sp = P(k), sv = findV(sp, s.id); if (s.on && sv && sv.available) L.push(line(k, STEP_PREP, sp, sv, s.qty)); });
    clearLines().forEach(function(l){ L.push(l); });
    return L;
  }
  /* the clear line, plus VC102 hardener when VC100 is chosen on its own: both or neither, same quantity */
  function clearLines(){
    if (S.clear.key === 'none') return [];
    var cp = P(S.clear.key), cv = findV(cp, S.clear.id);
    if (!cv || !cv.available) return [];
    var out = [line('clear', STEP_CLEAR, cp, cv, S.clear.qty)];
    if (S.clear.key === 'clear_vc100') {
      var hv = hardenerV(); if (!hv) return [];
      var hl = line('hardener', STEP_CLEAR, P('hardener'), hv, S.clear.qty); hl.lock = true; hl.sub = [hl.sub, D.notes.hardener].filter(Boolean).join(' · ');
      out.push(hl);
    }
    return out;
  }
  function noClear(){ return !clearLines().length; }
  function kbTotal(L){ var t = 0; L.forEach(function(l){ t += l.price * l.qty; }); return t; }
  function kbPayload(L, kit){
    var by = {}, order = [];
    L.forEach(function(l){
      if (!by[l.id]) { by[l.id] = { id: l.id, quantity: 0, properties: { _kit: kit } }; order.push(l.id); }
      by[l.id].quantity += l.qty;
      if (l.props) Object.keys(l.props).forEach(function(k){ if (k !== '_kit') by[l.id].properties[k] = l.props[k]; });
    });
    return order.map(function(id){ return by[id]; });
  }

  /* ---------- theme hooks (no edit to tr-product-page) ---------- */
  var page, buyCol, form, pills;
  function pillFor(id){ for (var i = 0; i < pills.length; i++) { if (+pills[i].getAttribute('data-variant-id') === id) return pills[i]; } return null; }
  function activePillId(){ var a = page.querySelector('.trpd-size.is-active'); return a ? +a.getAttribute('data-variant-id') : null; }
  function guardsOk(){
    if (!page || !buyCol || !form || !D.paint || !D.paint.variants.length) return false;
    if (D.paint.variants.length > 1) {
      if (pills.length !== D.paint.variants.length) return false;
      for (var i = 0; i < D.paint.variants.length; i++) { if (!pillFor(D.paint.variants[i].id)) return false; }
    }
    for (var j = 0; j < D.paint.variants.length; j++) { if (D.paint.variants[j].available) return true; }
    return false;
  }
  /* size picked by the shopper: drive the theme pill so its hidden id and variant image follow */
  /* Sample picked: only the flag changes (the theme pill stays on the paint size; the sample product has no pill) */
  function setSample(){ if (!SMP || isSample()) return; S.smp = true; S.smpQty = 1; }
  function setSize(id, drivePill){
    var v = paintV(id); if (!v || !v.available) return;
    /* back from Sample to the size picked before it: nothing changed while the sample was picked, so the kit is as it was */
    var wasSmp = isSample(); S.smp = false;
    if (wasSmp && id === S.paintId) return;
    /* a new size re-applies that size's defaults (owner 2026-10-28): its clear (an aerosol clear on Aerosol / Pint, the
       Speed Kit on Quart / Gallon, which never offer aerosol clears) and its clear / primer quantities */
    if (id !== S.paintId) { S.paintQty = 1; S.reducer.auto = true; S.reducer.on = true; S.clear.auto = true; S.primer.auto = true; S.clear.picked = false; }
    S.paintId = id;
    if (S.clear.key !== 'none' && !clearAllowed(S.clear.key)) S.clear.picked = false;
    /* aerosol: the Color only reducer add-on is dropped too, so going back to a liquid size starts it unchecked again */
    if (!isLiquid()) S.reducer.colorOn = false;
    if (drivePill) { var pill = pillFor(id); if (pill && !pill.classList.contains('is-active')) pill.click(); }
    syncReducer(); applyClearDefault(); syncKitQty();
  }

  /* ---------- rendering ---------- */
  var ui, live, alertBox, lastLive = '', lastWarn = '';
  function STEPS(){ return [D.copy.step1, D.copy.step2, D.copy.step3, D.copy.step4]; }
  /* steps on the rail: Color only skips clear and primer; buttons keep their real step index */
  function railSteps(){ return smpCustom() ? [0] : (S.mode === 'color' || isSample()) ? [0, 3] : [0, 1, 2, 3]; }
  function qtyCtl(role, q, max, label){
    var lo = q <= 1, hi = q >= max;
    return '<span class="trkb-qty" role="group" aria-label="' + esc('Quantity of ' + label) + '">' +
      '<button type="button" data-act="qty" data-role="' + role + '" data-d="-1" data-k="q-' + role + '-m" aria-label="' + esc('Decrease quantity of ' + label) + '"' + (lo ? ' aria-disabled="true"' : '') + '>&minus;</button>' +
      '<output>' + q + '</output>' +
      '<button type="button" data-act="qty" data-role="' + role + '" data-d="1" data-k="q-' + role + '-p" aria-label="' + esc('Increase quantity of ' + label) + '"' + (hi ? ' aria-disabled="true"' : '') + '>+</button></span>';
  }
  function img(src){ return src ? '<img class="trkb-thumb" src="' + esc(src) + '" alt="" width="44" height="44" loading="lazy">' : '<span class="trkb-thumb" aria-hidden="true"></span>'; }
  function chips(role, p, selId){
    if (!p || p.variants.length < 2) return '';
    return '<span class="trkb-chips" role="radiogroup" aria-label="' + esc(nice(p.title) + ' option') + '">' + p.variants.map(function(v){
      return '<label class="trkb-chip-opt"><input type="radio" name="trkb-' + SID + '-' + role + '-v" value="' + v.id + '" data-act="variant" data-role="' + role + '" data-k="v-' + role + '-' + v.id + '"' + (v.id === selId ? ' checked' : '') + (v.available ? '' : ' disabled') + '><span>' + esc(vLabel(v)) + '</span></label>';
    }).join('') + '</span>';
  }
  function option(o){
    /* o: type, name, value, act, on, avail, p (product, or null for no thumb), title, note, price, extra, tag; optional key, offText */
    var key = o.key || ('o-' + o.name + '-' + o.value);
    return '<div class="trkb-opt' + (o.cls ? ' ' + o.cls : '') + (o.on ? ' is-on' : '') + (o.avail ? '' : ' is-off') + (o.p === null ? ' no-thumb' : '') + '"><label class="trkb-opt-main">' +
      '<input type="' + o.type + '" name="' + esc(o.name) + '" value="' + esc(o.value) + '" data-act="' + o.act + '" data-k="' + esc(key) + '"' + (o.on ? ' checked' : '') + (o.avail ? '' : ' disabled') + '>' +
      (o.p === null ? '' : img(o.p && o.p.image)) +
      '<span><span class="trkb-opt-t">' + esc(o.title) + (o.tag || '') + '</span>' + (o.note ? '<span class="trkb-opt-s">' + esc(o.note) + '</span>' : '') + (o.avail ? '' : '<span class="trkb-opt-s">' + esc(o.offText || 'Sold out') + '</span>') + '</span>' +
      '<span class="trkb-opt-p">' + (o.price || '') + '</span></label>' +
      (o.extra ? '<div class="trkb-opt-x">' + o.extra + '</div>' : '') + '</div>';
  }
  /* only the first heading of a step takes data-k="h" (focus target after a step change) */
  function heading(text, tagHtml){ return '<h3 class="trkb-h" tabindex="-1" data-k="h">' + esc(text) + (tagHtml || '') + '</h3>'; }
  function subHeading(text){ return '<h3 class="trkb-h">' + esc(text) + '</h3>'; }
  function undercoatText(){ return D.paint.undercoat ? fill(D.copy.undercoatNote, { code: D.paint.undercoat }) : D.copy.undercoatNoteNoCode; }

  function modeGroup(){
    /* Sample picked: the choice stays in place (no layout jump) but is locked and unticked; S.mode itself is untouched */
    var smp = isSample();
    var h = heading(D.copy.modeHeading) + '<fieldset class="trkb-group trkb-tiles trkb-mode' + (smp ? ' is-locked' : '') + '" role="radiogroup"' + (smp ? ' disabled aria-disabled="true"' : '') + '><legend class="trkb-sr">' + esc(D.copy.modeHeading) + '</legend>';
    [['kit', D.copy.modeKit, lq('modeKitNote', 'modeKitNoteLiquid')], ['color', D.copy.modeColor, lq('modeColorNote', 'modeColorNoteLiquid')]].forEach(function(m){
      h += option({ type: 'radio', name: 'trkb-' + SID + '-mode', value: m[0], act: 'mode', on: !smp && S.mode === m[0], avail: !smp, offText: m[0] === 'kit' ? D.copy.sampleLocked : ' ', p: null, title: m[1], note: smp ? '' : m[2], key: 'm-' + m[0] });
    });
    return h + '</fieldset>';
  }
  function aerosolHint(){
    if (isSample()) return '';
    /* Body colors (most of the catalog) get the body hint; the "set of four" wording is for wheel colors only. */
    var t = D.copy.isWheel && D.copy.aerosolHintWheel ? D.copy.aerosolHintWheel : D.copy.aerosolHint;
    /* Pint/Quart/Gallon: the size hint (body colors only; its jobs are body panels). Same figures as How much paint. */
    if (isLiquid()) t = D.copy.isWheel ? '' : D.copy.liquidHint;
    if (!t) return '';
    /* draft QA 2026-10-23: a 2-stage / undercoat color's Aerosol is a two-can set, so count sets, not single cans */
    if (!isLiquid() && stageCount() === 2) t = t.replace(/cans of color/g, 'two-can sets').replace(/can of color/g, 'two-can set');
    return '<p class="trkb-hint">' + esc(t) + (D.copy.guideSection ? ' <a href="#trcg-qty">How much paint do I need <span aria-hidden="true">&rarr;</span></a>' : '') + '</p>';
  }
  /* Complete kit: says what clear and primer the size gets (syncKitQty): scales on Aerosol, fixed on Pint / Quart / Gallon */
  function scaleHint(){
    /* the "set of four wheels" Pint wording is for wheel colors only */
    var c = sizeClass(), t = c === 'pint' ? (D.copy.isWheel && D.copy.kitScaleHintPintWheel ? D.copy.kitScaleHintPintWheel : D.copy.kitScaleHintPint) : c === 'big' ? D.copy.kitScaleHintBig : D.copy.kitScaleHint;
    if (!t || isSample() || S.mode !== 'kit') return '';
    if (c === 'aero' && stageCount() === 2) t = t.replace(/color cans/g, 'two-can sets').replace(/color can/g, 'two-can set').replace(/\bcans\b/g, 'sets');
    return '<p class="trkb-hint trkb-scale-hint">' + esc(t) + '</p>';
  }
  function sampleNote(){
    if (!SMP || !D.copy.sampleNote) return '';
    return '<p class="trkb-note trkb-sample-note">' + esc(fill(D.copy.sampleNote, { price: money(SMP.price) })) +
      (D.copy.sampleLink && D.copy.sampleLinkText ? ' <a href="' + esc(D.copy.sampleLink) + '">' + esc(D.copy.sampleLinkText) + ' <span aria-hidden="true">&rarr;</span></a>' : '') + '</p>';
  }
  function stepColor(){
    var h = modeGroup() + heading(D.copy.sizeHeading);
    if (D.paint.single) {
      var v0 = D.paint.variants[0];
      h += '<div class="trkb-opt is-on is-static"><div class="trkb-opt-main"><span><span class="trkb-opt-t">' + esc(D.paint.name) + '</span><span class="trkb-opt-s">' + esc(AERO_SIZE) + ' · ready to spray</span></span><span class="trkb-opt-p">' + money(v0.price) + '</span></div>' +
        '<div class="trkb-opt-x">' + qtyCtl('paint', S.paintQty, capFor(v0), D.paint.name) + '</div></div>';
      h += scaleHint() + aerosolHint();
    } else {
      /* sizes render as tiles with the quantity stepper under the grid */
      var selV = null, smp = isSample();
      h += '<fieldset class="trkb-group trkb-tiles trkb-sizes"><legend class="trkb-sr">' + esc(D.copy.sizeHeading) + '</legend>';
      D.paint.variants.forEach(function(v){
        var sz = sizeOf(v), oz = vol(sz), on = !smp && v.id === S.paintId;
        if (on) selV = v;
        /* two-container pearls ship a Stage 1/2 and a Stage 2/2 container per size; both are reduced 2:1 */
        var two = D.paint.twoContainers;
        /* un-reduced oz plus the ready-to-spray volume at 2 parts paint : 1 part reducer (oz + oz / 2: 16 -> 24, 32 -> 48, 128 -> 192) */
        var rts = oz + oz / 2;
        var note = oz ? (two ? 'Stage 1 + Stage 2, ' + oz + ' oz each · about ' + rts + ' oz each to spray · spray gun' : oz + ' oz un-reduced · about ' + rts + ' oz to spray · spray gun') : (two ? 'Stage 1 + Stage 2, ' + AERO_SIZE + ' each · ready to spray' : (D.paint.needsUndercoat ? 'Undercoat + color, ' + AERO_SIZE + ' each · ready to spray' : AERO_SIZE + ' · ready to spray, no mixing'));
        h += option({ type: 'radio', name: 'trkb-' + SID + '-size', value: v.id, act: 'size', on: on, avail: v.available, p: null, title: sz,
          note: v.available ? note : '', offText: 'Unavailable', price: money(v.price), extra: '' });
      });
      /* the Sample tile: a full-width row under the paint sizes, at the sample product's Standard or Special price */
      if (SMP) h += option({ type: 'radio', name: 'trkb-' + SID + '-size', value: 'sample', act: 'size', on: smp, avail: true, p: null, title: 'Sample', cls: 'is-sample',
        note: D.copy.sampleSub, price: money(SMP.price), extra: '', key: 'o-sample' });
      h += '</fieldset>';
      /* the split: "This color" (the sample line as before) or "Enter your color" (the shared form, in the slot) */
      if (smp && smpEl) h += '<fieldset class="trkb-group trkb-smp-src"><legend class="trkb-sr">Sample of</legend>' +
        [['this', 'This color'], ['custom', 'Enter your color']].map(function(o, i){
          return (i ? '<span class="trkb-smp-or" aria-hidden="true">or</span>' : '') + '<label class="trkb-smp-seg"><input type="radio" name="trkb-' + SID + '-smpsrc" value="' + o[0] + '" data-act="smpsrc" data-k="s-' + o[0] + '"' + (S.smpSrc === o[0] ? ' checked' : '') + '><span>' + o[1] + '</span></label>';
        }).join('') + '</fieldset>';
      if (smpCustom()) return h + '<div class="trkb-smp-slot" data-trkb-smp-slot></div>';
      if (smp) h += '<div class="trkb-tile-qty"><span class="trkb-tile-ql" aria-hidden="true">Quantity</span>' + qtyCtl('paint', S.smpQty, capFor({ max: SMP.max, cap: SMP_CAP }), 'Sample') + '</div>';
      else if (selV) h += '<div class="trkb-tile-qty"><span class="trkb-tile-ql" aria-hidden="true">Quantity</span>' + qtyCtl('paint', S.paintQty, capFor(selV), sizeOf(selV)) + '</div>' + scaleHint() + aerosolHint();
      /* owner 2026-10-23: one aerosol price per can; a 2-stage or undercoat color's aerosol is two cans, so say so plainly while Aerosol is picked */
      if (selV && !vol(sizeOf(selV)) && stageCount() === 2 && D.copy.aerosolTwoCanNote) h += '<p class="trkb-note">' + esc(fill(D.copy.aerosolTwoCanNote, {
        cans: D.paint.twoContainers ? 'Stage 1 + Stage 2' : 'undercoat + color', each: money(selV.price / 2), total: money(selV.price) })) + '</p>';
    }
    /* Sample: one short note (the credit at the Sample price) instead of the stage / undercoat notes, which describe paint sizes */
    if (isSample()) return h + sampleNote();
    /* a named undercoat code on a two-container color is Stage 1, included (owner 2026-10-04, e.g. Ford APU117) */
    if (D.paint.twoContainers) h += '<p class="trkb-note">' + esc(noRed(D.copy.twoContainerNote)) + (D.paint.undercoat && D.copy.twoContainerCodeNote ? ' ' + esc(fill(D.copy.twoContainerCodeNote, { code: D.paint.undercoat })) : '') +
      (isLiquid() && D.copy.twoContainerReducerNote && !/reduc/i.test(D.copy.twoContainerNote || '') ? ' ' + esc(D.copy.twoContainerReducerNote) : '') + '</p>';
    /* the undercoat is included at one price (owner 2026-10-04): a neutral info note, never a warning */
    if (D.paint.needsUndercoat) h += '<p class="trkb-note">' + esc(undercoatText()) + '</p>';
    else if (D.paint.coat && !D.paint.twoContainers) h += '<p class="trkb-note">' + esc(D.copy.coatNote) + '</p>';
    return h;
  }
  function reqTag(){ return D.copy.requiredTag ? ' <span class="trkb-tag is-red">' + esc(D.copy.requiredTag) + '</span>' : ''; }
  /* the reducer's own tag ("Highly recommended", navy fill); the clear coat keeps the red "Required" */
  function reducerTag(){ return D.copy.reducerTag ? ' <span class="trkb-tag is-hirec">' + esc(D.copy.reducerTag) + '</span>' : ''; }
  /* the reducer row; qty: stepper on the row once checked (kit step 2 and the Color only add-on) */
  function reducerOpt(on, qty){
    var rp = P('reducer'), rv = findV(rp, S.reducer.id) || firstAvail(rp);
    return option({ type: 'checkbox', name: 'trkb-' + SID + '-reducer', value: 'on', act: 'reducer', on: on && !!rv, avail: !!rv, p: rp, title: nice(rp.title),
      note: D.copy.reducerNote, price: rv ? money(rv.price) : '', extra: (qty && on && rv ? qtyCtl('reducer', S.reducer.qty, capFor(rv), nice(rp.title)) : ''), tag: reducerTag() });
  }
  /* reducer: first thing in Prep & primer, liquid sizes only (aerosol is ready to spray) */
  function reducerBlock(){
    if (S.mode === 'color' || !isLiquid() || !P('reducer')) return '';
    var h = heading(D.copy.reducerHeading || 'Reducer') + reducerOpt(S.reducer.on, true);
    var ri = reducerIssue(); if (ri) h += '<p class="trkb-note is-warn">' + esc(ri) + '</p>';
    return h;
  }
  /* Color only on a liquid size: the same reducer as a pre-unchecked add-on at review (never on aerosol); once ticked it
     keeps its quantity stepper here and is not repeated as a review line */
  function reducerAddOn(){
    if (S.mode !== 'color' || isSample() || !isLiquid() || !P('reducer')) return '';
    return '<div class="trkb-addon">' + reducerOpt(S.reducer.colorOn, true) + '</div>';
  }
  /* VC100's hardener, shown indented under the selected VC100 option: locked, follows the VC100 quantity */
  function companion(){
    var hl = null; clearLines().forEach(function(l){ if (l.role === 'hardener') hl = l; });
    if (!hl) return '';
    return '<div class="trkb-comp">' + img(hl.image) + '<span><span class="trkb-opt-t">' + esc(hl.title) + '</span><span class="trkb-opt-s">' + esc(hl.sub) + '</span></span>' +
      '<span class="trkb-opt-p">' + money(hl.price) + '</span></div>';
  }
  function stepClear(){
    /* the step is Required (badge on heading and rail); the default option is tagged Recommended */
    var h = heading(D.copy.clearHeading, reqTag());
    if (D.copy.clearRequiredNote) h += '<p class="trkb-note is-red trkb-callout" role="note"><strong>' + esc(D.copy.clearRequiredNote) + '</strong></p>';
    if (D.copy.clearIntro) h += '<p class="trkb-p">' + esc(D.copy.clearIntro) + '</p>';
    if (S.notice) h += '<p class="trkb-note is-warn">' + esc(S.notice) + '</p>';
    h += '<fieldset class="trkb-group"><legend class="trkb-sr">' + esc(D.copy.clearHeading) + '</legend>';
    var rec = recommendedClear(), order = clearOrder();
    order.forEach(function(k){
      var p = P(k); if (!p) return;
      var on = S.clear.key === k, sel = on ? findV(p, S.clear.id) : firstAvail(p), avail = clearAvail(k);
      var tag = (k === rec && D.copy.recommendedTag) ? ' <span class="trkb-tag">' + esc(D.copy.recommendedTag) + '</span>' : '';
      if (!isLiquid() && isGunClear(k) && D.copy.gunTag) tag += ' <span class="trkb-tag is-muted">' + esc(D.copy.gunTag) + '</span>';
      h += option({ type: 'radio', name: 'trkb-' + SID + '-clear', value: k, act: 'clear', on: on && avail, avail: avail, p: p, title: nice(p.title), note: D.notes[k], price: sel ? money(sel.price) : '',
        extra: on && avail ? chips('clear', p, S.clear.id) + qtyCtl('clear', S.clear.qty, clearCap(sel), nice(p.title)) + companion() : '', tag: tag });
    });
    h += option({ type: 'radio', name: 'trkb-' + SID + '-clear', value: 'none', act: 'clear', on: S.clear.key === 'none', avail: true, p: null, title: 'No clear coat' });
    h += '</fieldset>';
    if (noClear()) h += '<p class="trkb-note is-red">' + esc(D.copy.noClearWarn) + '</p>';
    return h;
  }
  function stepPrimer(){
    var h = reducerBlock(), first = !h;
    h += (first ? heading(D.copy.primerHeading) : subHeading(D.copy.primerHeading)) + '<p class="trkb-p">' + esc(D.copy.primerIntro) + '</p>';
    if (isLiquid() && D.copy.liquidPrimerNote) h += '<p class="trkb-note">' + esc(D.copy.liquidPrimerNote) + '</p>';
    var pmm = primerMismatch(), ppn = pmm ? '' : primerPickNote();
    if (pmm) h += '<p class="trkb-note trkb-primer-other">' + esc(pmm) + '</p>';
    else if (ppn) h += '<p class="trkb-note trkb-primer-pick">' + esc(ppn) + '</p>';
    h += '<fieldset class="trkb-group"><legend class="trkb-sr">' + esc(D.copy.primerHeading) + '</legend>';
    PRIMERS.forEach(function(k){
      var p = P(k); if (!p) return;
      var on = S.primer.key === k, sel = on ? findV(p, S.primer.id) : shadeVariant(p), avail = !!firstAvail(p);
      h += option({ type: 'radio', name: 'trkb-' + SID + '-primer', value: k, act: 'primer', on: on, avail: avail, p: p, title: nice(p.title),
        note: k === 'primer_1' ? D.copy.primer1Sub : fill(D.notes[k], { shade: SHADE }), price: sel ? money(sel.price) : '',
        extra: on ? chips('primer', p, S.primer.id) + qtyCtl('primer', S.primer.qty, capFor(sel), nice(p.title)) : '' });
    });
    h += option({ type: 'radio', name: 'trkb-' + SID + '-primer', value: 'none', act: 'primer', on: S.primer.key === 'none', avail: true, p: null, title: 'No primer' });
    h += '</fieldset>';
    if (primerInfo()) h += '<p class="trkb-note">' + esc(primerInfo()) + '</p>';
    else if (S.primer.key === 'primer_1' && D.copy.primerApplyNote) h += '<p class="trkb-note trkb-primer-apply">' + esc(D.copy.primerApplyNote) + '</p>';
    if (D.copy.showSupplies && SUPPLIES.some(function(k){ return !!P(k); })) {
      h += '<h3 class="trkb-h">' + esc(D.copy.suppliesHeading) + '</h3><fieldset class="trkb-group"><legend class="trkb-sr">' + esc(D.copy.suppliesHeading) + '</legend>';
      SUPPLIES.forEach(function(k){
        var p = P(k); if (!p) return;
        var s = S.supplies[k], sel = findV(p, s.id) || firstAvail(p), avail = !!firstAvail(p);
        h += option({ type: 'checkbox', name: 'trkb-' + SID + '-' + k, value: k, act: 'supply', on: s.on && avail, avail: avail, p: p, title: nice(p.title), note: D.notes[k], price: sel ? money(sel.price) : '',
          extra: s.on && avail ? chips(k, p, s.id) + qtyCtl(k, s.qty, capFor(sel), nice(p.title)) : '' });
      });
      h += '</fieldset>';
    }
    return h;
  }
  function reducerShort(){
    if (!isLiquid() || !S.reducer.on) return 0;
    var rv = findV(P('reducer'), S.reducer.id), have = rv ? vol(rv.title) * S.reducer.qty : 0, need = reducerNeed();
    return have > 0 && have < need ? Math.ceil(need) : 0;
  }
  function reducerIssue(){
    if (!isLiquid() || S.mode === 'color') return '';
    if (!P('reducer') || !S.reducer.on) return 'No reducer in this kit. We highly recommend it: Pint, Quart and Gallon ship un-reduced, and the basecoat must be mixed 2 parts paint to 1 part reducer before you spray.';
    if (!S.reducer.id || !firstAvail(P('reducer'))) return 'Reducer is sold out right now. Pint, Quart and Gallon ship un-reduced, and the basecoat must be mixed 2 parts paint to 1 part TrueRim urethane reducer before you spray; email us if you need it.';
    var short = reducerShort();
    if (short) { var rp = reducerPick(), rv = rp && findV(P('reducer'), rp.id); return 'Not enough reducer for this much paint. At 2 parts paint to 1 part reducer you need about ' + short + ' oz' + (stageCount() > 1 ? ' for both stages' : '') + (rv ? ': ' + rp.qty + ' \u00d7 ' + vLabel(rv) : '') + '.'; }
    return '';
  }
  function warnings(){
    var w = [];
    if (S.mode === 'color' || isSample()) return w;
    var ri = reducerIssue(); if (ri) w.push(ri);
    if (noClear()) w.push(D.copy.noClearWarn);
    return w;
  }
  /* no primer is a valid choice over sound, sanded factory paint (guide: "Sound factory paint needs no primer"),
     so it is an information note, never a warning or a rail warn state */
  function primerInfo(){ return (S.mode !== 'color' && !isSample() && S.primer.key === 'none') ? D.copy.noPrimerNote : ''; }
  function guideRow(){
    if (!D.copy.showPrintedGuide || isSample()) return '';
    return option({ type: 'checkbox', name: 'trkb-' + SID + '-guide', value: 'on', act: 'guide', on: S.guide.on, avail: true, p: null,
      title: fill(D.copy.guideLabel, { method: isLiquid() ? 'spray-gun' : 'aerosol' }), note: D.copy.guideSub, key: 'guide' });
  }
  function stepReview(){
    var L = kbLines(), smp = isSample(), color = S.mode === 'color' || smp, n = 0, b = '';
    L.forEach(function(l){ n += l.qty; });
    b += '<table class="trkb-lines"><thead class="trkb-sr"><tr><th>Image</th><th>Item and quantity</th><th>Price</th><th>Actions</th></tr></thead><tbody>';
    L.forEach(function(l){
      /* Color only: the reducer is shown once, as the add-on card below (with its own stepper), never also as a line */
      if (color && l.role === 'reducer') return;
      var label = l.title + (l.sub ? ', ' + l.sub : '');
      /* a locked line (VC100's hardener) has no Change/Remove/stepper of its own: it follows the VC100 line */
      var acts = l.lock ? '' : '<button type="button" class="trkb-link" data-act="edit" data-step="' + l.step + '" data-k="e-' + l.role + '" aria-label="' + esc('Change ' + label) + '">Change</button>';
      if (!l.fixed && !l.lock) acts += '<button type="button" class="trkb-link" data-act="remove" data-role="' + l.role + '" data-k="r-' + l.role + '" aria-label="' + esc('Remove ' + label) + '">Remove</button>';
      var qc = l.lock ? '<span class="trkb-comp-q">Qty ' + l.qty + '</span>' : qtyCtl(l.role, l.qty, l.role === 'clear' ? clearCap(l) : capFor(l), label);
      b += '<tr' + (l.lock ? ' class="is-comp"' : '') + '><td class="trkb-c-img">' + img(l.image) + '</td><td><span class="trkb-opt-t">' + esc(l.title) + '</span>' + (l.sub ? '<span class="trkb-opt-s">' + esc(l.sub) + '</span>' : '') +
        '<span class="trkb-opt-s">' + qc + '</span></td>' +
        '<td class="trkb-c-p">' + money(l.price * l.qty) + '</td><td class="trkb-c-a"><span class="trkb-acts">' + acts + '</span></td></tr>';
    });
    b += '</tbody></table>';
    b += reducerAddOn() + guideRow();
    var w = warnings();
    w.forEach(function(t){ b += '<p class="trkb-note is-warn">' + esc(t) + '</p>'; });
    if (D.paint.needsUndercoat && !smp) b += '<p class="trkb-note">' + esc(undercoatText()) + '</p>';
    if (smp) {
      /* nothing else is needed for a sample */
    } else if (color) {
      /* one plain note on what else is needed; it never blocks Add to Cart */
      b += '<p class="trkb-note">' + esc(isLiquid() ? D.copy.colorOnlyLiquid : D.copy.colorOnlyAerosol) +
        ' <button type="button" class="trkb-link" data-act="mode" value="kit" data-k="m-switch">Switch to complete kit</button></p>';
      if (primerColorOnly()) b += '<p class="trkb-note trkb-primer-pick">' + esc(primerColorOnly()) + '</p>';
    } else {
      if (primerInfo()) b += '<p class="trkb-note">' + esc(primerInfo()) + '</p>';
      else if (!w.length) b += '<p class="trkb-note">' + (isLiquid() ? 'Color, reducer, clear coat and primer are all in your kit.' : 'Color, clear coat and primer are all in your kit.') + '</p>';
      /* safety stated once: with the color guide on the page, a short line points to its safety notes */
      if (!noClear()) {
        if (D.copy.safetyLinkOnly && D.copy.guideSection && D.copy.safetyShort) b += '<p class="trkb-note is-red"><a href="#trcg-apply">' + esc(D.copy.safetyShort) + '</a></p>';
        else b += '<p class="trkb-note is-red">' + esc(isGunClear(S.clear.key) ? D.copy.safetyGun : D.copy.safetyAerosol) + '</p>';
      }
    }
    if (D.copy.showFreeShip && D.minSpend > 0) {
      var gap = D.minSpend - D.cartTotal - kbTotal(L);
      if (gap > 0) b += '<p class="trkb-note">' + esc(fill(D.copy.freeShipText, { amount: money(gap), min: money(D.minSpend).replace(/[.,]00/, '') })) + '</p>';
    }
    if (D.copy.isWheel && D.copy.showProdiy && D.copy.prodiyUrl && !isLiquid() && !smp) b += '<p class="trkb-note"><a href="' + esc(D.copy.prodiyUrl) + '">' + esc(D.copy.prodiyText) + '</a></p>';
    var h = heading(color ? (D.copy.reviewHeadingColor || D.copy.reviewHeading) : D.copy.reviewHeading);
    return h + '<div class="trkb-card"><div class="trkb-card-h"><span>' + (smp ? 'Your sample' : color ? 'Your paint' : 'Your paint kit') + '</span><span>' + n + (n === 1 ? ' item' : ' items') + '</span></div>' +
      '<div class="trkb-card-b">' + b + '<div class="trkb-card-t"><span>' + (color ? 'Total' : 'Kit total') + '</span><strong>' + money(kbTotal(L)) + '</strong></div></div></div>';
  }

  /* rail state comes from kit contents, not from which steps were visited */
  function stepState(i){
    if (railSteps().indexOf(i) < 0) return '';
    if (i === STEP_PREP && reducerIssue()) return 'warn';
    if (i === STEP_CLEAR && noClear()) return 'warn';
    return (i < 3 && i !== S.step && S.seen[i]) ? 'done' : '';
  }
  function render(){
    var act = document.activeElement, focusKey = act && ui.contains(act) ? act.getAttribute('data-k') : null;
    var L = kbLines(), T = kbTotal(L), n = 0; L.forEach(function(l){ n += l.qty; });
    var smp = isSample(), labels = STEPS(), last = S.step === 3, rs = railSteps(), totalL = (S.mode === 'color' || smp) ? 'Total' : 'Kit total';
    /* 2026-10-22: the Complete kit already has every default picked (paint, primer, clear + hardener, reducer on liquid
       sizes), so step 1 offers it in one tap; "Customize kit" walks the steps as before. Same submit() as the review step. */
    var quick = !last && S.mode === 'kit' && !smp && S.step === 0 && !warnings().length;   /* any warning: the steps show it first */
    /* Sample: one tap from step 1 (the review step stays on the rail) */
    var addNow = last || (smp && S.step === 0);
    var h = '<div class="trkb-head"><div>' +
      (D.copy.eyebrow ? '<p class="trkb-eyebrow">' + esc(D.copy.eyebrow) + '</p>' : '') + '<h2 class="trkb-title">' + esc(fill(D.copy.heading, { color: D.paint.name })) + '</h2>' +
      (lq('intro', 'introLiquid') ? '<p class="trkb-intro">' + esc(lq('intro', 'introLiquid')) + '</p>' : '') + '</div></div>';
    var custom = smpCustom();
    if (!custom) h += '<ol class="trkb-rail' + (rs.length === 2 ? ' is-2' : '') + '" aria-label="Kit steps">' + rs.map(function(i, pos){
      var st = stepState(i), l = labels[i], rq = i === STEP_CLEAR ? reqTag() : '';
      return '<li><button type="button" class="trkb-rail-btn' + (st ? ' is-' + st : '') + '" data-act="go" data-step="' + i + '" data-k="g-' + i + '"' + (i === S.step ? ' aria-current="step"' : '') + '>' +
        '<span class="trkb-rail-n" aria-hidden="true">' + (st === 'done' ? '&#10003;' : st === 'warn' ? '!' : (pos + 1)) + '</span><span class="trkb-rail-l">' + esc(l) + rq + '</span>' +
        '<span class="trkb-sr">' + (st === 'done' ? ' (done)' : st === 'warn' ? ' (needs attention)' : '') + '</span></button></li>';
    }).join('') + '</ol>';
    h += '<div class="trkb-body' + (custom ? ' is-smp-custom' : '') + '" role="region" aria-label="' + esc('Step ' + (rs.indexOf(S.step) + 1) + ' of ' + rs.length + ': ' + labels[S.step]) + '">' +
      [stepColor, stepPrimer, stepClear, stepReview][S.step]() + '</div>';
    /* Enter your color: the form carries its own price, quantity and Add button, so the kit footer steps aside */
    if (!custom) h += '<div class="trkb-foot"><p class="trkb-msg' + (S.msgType ? ' is-' + S.msgType : '') + '">' + esc(S.msg) + '</p>' +
      (S.step > 0 ? '<button type="button" class="trkb-back" data-act="back" data-k="back"><span aria-hidden="true">&larr; </span>Back</button>' : '') +
      '<div class="trkb-total"><span class="trkb-total-l">' + totalL + '</span><span class="trkb-total-v">' + money(T) + '</span><span class="trkb-total-n">' + n + (n === 1 ? ' item' : ' items') + '</span></div>' +
      (addNow ? '<button type="button" class="trkb-go" data-act="add" data-k="add"' + (L.length && !S.busy ? '' : ' aria-disabled="true"') + (S.busy ? ' aria-busy="true"' : '') + '>' + (S.busy ? 'Adding&hellip;' : esc(L.length === 1 ? 'Add to Cart' : 'Add Kit to Cart')) + '</button>'
            : quick ? '<button type="button" class="trkb-go is-next is-alt" data-act="next" data-k="next">Customize kit<span aria-hidden="true"> &rarr;</span></button>' +
              '<button type="button" class="trkb-go" data-act="add" data-k="add"' + (L.length && !S.busy ? '' : ' aria-disabled="true"') + (S.busy ? ' aria-busy="true"' : '') + '>' + (S.busy ? 'Adding&hellip;' : 'Add recommended kit') + '</button>'
            : '<button type="button" class="trkb-go is-next" data-act="next" data-k="next">Next Step<span aria-hidden="true"> &rarr;</span></button>') + '</div>';
    ui.innerHTML = h;
    var slot = custom && ui.querySelector('[data-trkb-smp-slot]');
    if (slot) slot.appendChild(smpEl);
    if (focusKey) { var f = ui.querySelector('[data-k="' + focusKey + '"]') || ui.querySelector('[data-k="h"]'); if (f) f.focus({ preventScroll: true }); }
    var warnText = last ? warnings().join(' ') : '', say = custom ? '' : totalL + ' ' + money(T) + ', ' + n + (n === 1 ? ' item.' : ' items.') + (warnText !== lastWarn ? ' ' + warnText : '');
    lastWarn = warnText;
    if (say !== lastLive) { lastLive = say; live.textContent = say; }
    /* 2026-10-22: the phone buy bar (truerim-buy-bar) mirrors the kit and can add it in one tap through trkb:add */
    emitState();
  }
  function emitState(){
    var L = kbLines(), T = kbTotal(L), smp = isSample(), pv0 = paintV(S.paintId);
    /* Enter your color: the bar shows the form's own price (its Standard / Special choice x quantity) and its busy state */
    var cs = smpCustom() && typeof smpEl.trsrState === 'function' ? smpEl.trsrState() : null;
    try { document.dispatchEvent(new CustomEvent('trkb:state', { detail: { size: smp ? 'Sample' : pv0 ? sizeOf(pv0) : '', mode: smp ? 'sample' : S.mode, sample: smp, total: money(cs ? cs.price : T), ready: cs ? !cs.busy : !!L.length && !S.busy && !warnings().length, busy: cs ? !!cs.busy : !!S.busy } })); } catch (e) {}
  }
  /* buy bar "Add": the same submit() as the review step; with a warning open, show the steps instead */
  function onBarAdd(){
    if (S.busy) return;
    /* Enter your color: the bar's Add runs the form's own submit (it checks the fields and shows any error inline) */
    if (smpCustom()) { if (typeof smpEl.trsrSubmit === 'function') { root.scrollIntoView({ block: 'start' }); smpEl.trsrSubmit(); } return; }
    if (!kbLines().length || warnings().length) { go(3); root.scrollIntoView({ block: 'start' }); return; }
    submit();
  }
  function setMsg(msg, type){ S.msg = msg; S.msgType = type; alertBox.textContent = ''; if (msg && type === 'err') alertBox.textContent = msg; }

  /* ---------- events ---------- */
  /* Color only never mutates the kit choices, so switching back restores them exactly */
  function setMode(m){ if (isSample()) return; S.mode = m === 'color' ? 'color' : 'kit'; if (S.step === 1 || S.step === 2) S.step = 0; }
  /* html[data-trkb-guide]: order = on the paint line already in the cart, fail = that change failed, on = rides on the next add */
  function syncGuideFlag(){ document.documentElement.dataset.trkbGuide = S.lastAdd && S.lastAdd.guided ? 'order' : S.guideFail ? 'fail' : guideOn() ? 'on' : 'off'; }
  /* tells the color guide which method tab matches the size (it also reads the html flag when it boots after us) */
  function sayMethod(){
    /* html[data-trkb-sample] + trkb:sample {on}: Complete the job hides while a sample is picked; the guide keeps its method tab */
    var smp = isSample();
    if (document.documentElement.dataset.trkbSample !== (smp ? '1' : '0')) {
      document.documentElement.dataset.trkbSample = smp ? '1' : '0';
      try { document.dispatchEvent(new CustomEvent('trkb:sample', { detail: { on: smp } })); } catch (e) {}
    }
    if (smp) return;
    var m = isLiquid() ? 'gun' : 'aerosol';
    document.documentElement.dataset.trkbMethod = m;
    try { document.dispatchEvent(new CustomEvent('trkb:method', { detail: { method: m } })); } catch (e) {}
  }
  function onGuide(e){
    if (!D.copy.showPrintedGuide) return;
    var on = !(e && e.detail && e.detail.on === false);
    if (S.busy) { S.guidePending = on; return; }   /* applied by done() when the add finishes */
    wantGuide(on);
  }
  function wantGuide(on){
    S.guide.on = on;
    if (on && S.lastAdd && !S.lastAdd.guided) { attachGuide(); return; }
    syncGuideFlag(); render();
  }
  function go(i){
    if (smpCustom()) i = 0;
    if ((S.mode === 'color' || isSample()) && i > 0 && i < 3) i = i === 1 ? 3 : 0;
    S.seen[S.step] = true; S.step = Math.max(0, Math.min(3, i)); setMsg('', ''); render();
    var b = ui.querySelector('[data-k="h"]'); if (b) b.focus({ preventScroll: true });
    if (ui.getBoundingClientRect().top < 0) root.scrollIntoView({ block: 'start', behavior: (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'auto' : 'smooth' });
  }
  function bump(role, d){
    var L = kbLines(), ln = null; L.forEach(function(l){ if (l.role === role) ln = l; });
    var max = ln ? capFor(ln) : 99;
    function nx(q){ return Math.max(1, Math.min(max, q + d)); }
    if (role === 'paint' && isSample()) S.smpQty = nx(S.smpQty);
    else if (role === 'paint') { S.paintQty = nx(S.paintQty); syncReducer(); syncKitQty(); }
    else if (role === 'reducer') { S.reducer.qty = nx(S.reducer.qty); S.reducer.auto = false; }
    else if (role === 'clear') { S.clear.qty = Math.min(nx(S.clear.qty), Math.max(1, clearCap(findV(P(S.clear.key), S.clear.id)))); S.clear.auto = false; }   /* hardener follows via kbLines() */
    else if (role === 'primer') { S.primer.qty = nx(S.primer.qty); S.primer.auto = false; }
    else if (S.supplies[role]) S.supplies[role].qty = nx(S.supplies[role].qty);
  }
  function onClick(e){
    var t = e.target.closest('[data-act]'); if (!t || !ui.contains(t)) return;
    var a = t.getAttribute('data-act');
    if (t.getAttribute('aria-disabled') === 'true') return;
    if (S.busy && a !== 'go' && a !== 'next' && a !== 'back') return;
    if (a === 'go' || a === 'edit') go(+t.getAttribute('data-step'));
    else if (a === 'next') go(S.step + 1);
    else if (a === 'back') go(S.step - 1);
    else if (a === 'qty') { if (S.msgType) setMsg('', ''); bump(t.getAttribute('data-role'), +t.getAttribute('data-d')); render(); }
    else if (a === 'remove') {
      if (S.msgType) setMsg('', '');
      var r = t.getAttribute('data-role');
      if (r === 'reducer') { if (S.mode === 'color') S.reducer.colorOn = false; else S.reducer.on = false; } else if (r === 'clear') { S.clear.key = 'none'; S.clear.picked = true; } else if (r === 'primer') S.primer.key = 'none'; else if (S.supplies[r]) S.supplies[r].on = false;
      render();
    }
    else if (a === 'mode' && t.tagName === 'BUTTON') { if (S.msgType) setMsg('', ''); setMode(t.value); render(); var mf = ui.querySelector('[data-k="h"]'); if (mf) mf.focus({ preventScroll: true }); }
    else if (a === 'add') submit();
  }
  function onChange(e){
    var t = e.target; var a = t.getAttribute && t.getAttribute('data-act'); if (!a) return;
    if (S.busy) { if (a === 'guide' && D.copy.showPrintedGuide) S.guidePending = t.checked; render(); return; }
    if (S.msgType) setMsg('', '');
    if (a === 'size') { if (t.value === 'sample') setSample(); else setSize(+t.value, true); sayMethod(); }
    else if (a === 'smpsrc') { if (isSample()) S.smpSrc = t.value === 'custom' && smpEl ? 'custom' : 'this'; }
    else if (a === 'mode') setMode(t.value);
    else if (a === 'guide') { if (t.checked && S.lastAdd && !S.lastAdd.guided) { wantGuide(true); return; } S.guide.on = t.checked; syncGuideFlag(); }
    else if (a === 'reducer' && isLiquid()) { if (S.mode === 'color') S.reducer.colorOn = t.checked; else S.reducer.on = t.checked; if (t.checked) { S.reducer.auto = true; syncReducer(); } }
    else if (a === 'clear') {
      /* switching away from VC100 drops its hardener. On any size a switch between an aerosol clear and a gun
         clear (or from No clear) changes the unit (cans vs one kit), so that size's default qty applies again */
      var was = S.clear.key; S.clear.picked = true; S.notice = ''; S.clear.key = t.value; var cv = firstAvail(P(t.value)); S.clear.id = cv ? cv.id : null;
      /* any aerosol <-> gun clear switch, on every size, goes back to clearFor(): a gun clear is always one kit, never a
         hand-set aerosol count carried over */
      if (was === 'none' || isGunClear(was) !== isGunClear(t.value)) S.clear.auto = true;
      S.clear.qty = clearKeep(S.clear.qty); syncKitQty();
    }
    else if (a === 'primer') { S.primer.key = t.value; var pv = shadeVariant(P(t.value)); S.primer.id = pv ? pv.id : null; S.primer.qty = Math.max(1, Math.min(S.primer.qty, capFor(pv))); syncKitQty(); }
    else if (a === 'supply') { var k = t.value; if (S.supplies[k]) { S.supplies[k].on = t.checked; S.supplies[k].qty = 1; } }
    else if (a === 'variant') {
      var role = t.getAttribute('data-role'), id = +t.value;
      if (role === 'clear') S.clear.id = id; else if (role === 'primer') S.primer.id = id; else if (S.supplies[role]) S.supplies[role].id = id;
      var p = role === 'clear' ? P(S.clear.key) : role === 'primer' ? P(S.primer.key) : P(role), cap = capFor(findV(p, id));
      if (role === 'clear') cap = clearCap(findV(p, id));
      if (role === 'clear' && S.clear.qty > cap) S.clear.qty = Math.max(1, cap);
      if (role === 'primer' && S.primer.qty > cap) S.primer.qty = Math.max(1, cap);
      if (S.supplies[role] && S.supplies[role].qty > cap) S.supplies[role].qty = Math.max(1, cap);
    }
    render();
  }

  /* ---------- cart ---------- */
  var ROOT = (D.root || '/').replace(/\/?$/, '/');
  var JSONH = { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
  function getCart(){ return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; }); }
  function post(path, body){
    return fetch(ROOT + path, { method: 'POST', headers: JSONH, body: JSON.stringify(body) })
      .then(function(r){ return r.json().then(function(j){ return { ok: r.ok, j: j || {} }; }, function(){ return { ok: r.ok, j: {} }; }); });
  }
  function overCap(L, cart){
    var inCart = {}; if (cart && cart.items) cart.items.forEach(function(i){ inCart[i.variant_id] = (inCart[i.variant_id] || 0) + i.quantity; });
    for (var i = 0; i < L.length; i++) {
      var l = L[i]; if (l.max == null) continue;
      if ((inCart[l.id] || 0) + l.qty > l.max) return 'We can’t add that many of ' + l.title + ' right now' + (inCart[l.id] ? ' (some are already in your cart)' : '') + '. Lower the quantity or pick another option.';
    }
    return '';
  }
  /* a rejected add can still leave part of the kit in the cart (Shopify adds what it can, then 422s): remove every line carrying this kit id */
  function kitKeys(c, kit){ var up = {}, any = false; (c && c.items || []).forEach(function(i){ if (i.properties && i.properties._kit === kit) { up[i.key] = 0; any = true; } }); return any ? up : null; }
  /* resolves to the cart after rollback only if no line with this kit id is left; null means "not verified" */
  function rollback(kit){
    return getCart().then(function(c){
      if (!c || !c.items) return null;
      var up = kitKeys(c, kit); if (!up) return c;
      return post('cart/update.js', { updates: up }).then(getCart).then(function(after){ return after && !kitKeys(after, kit) ? after : null; });
    }).catch(function(){ return null; });
  }
  /* refresh drawer markup and the cart bubble without opening the drawer over our error */
  function syncDrawer(drawer, cart){
    var list = drawer.getSectionsToRender();
    return fetch(ROOT + '?sections=' + list.map(function(s){ return s.id; }).join(','))
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(sections){
        if (!sections) return;
        list.forEach(function(s){
          var el = s.selector ? drawer.querySelector(s.selector) : document.getElementById(s.id);
          if (el && sections[s.id] && typeof drawer.getSectionInnerHTML === 'function') el.innerHTML = drawer.getSectionInnerHTML(sections[s.id], s.selector);
        });
        var ov = drawer.querySelector('#CartDrawer-Overlay');
        if (ov && typeof drawer.close === 'function') ov.addEventListener('click', drawer.close.bind(drawer));
        if (cart && typeof cart.item_count === 'number') drawer.classList.toggle('is-empty', cart.item_count === 0);
      }).catch(function(){});
  }
  function done(msg, type){
    S.busy = false; setMsg(msg, type); syncGuideFlag(); render();
    var g = S.guidePending; S.guidePending = null;
    if (g !== null) wantGuide(g);
  }
  /* printed guide asked for after this kit is in the cart: rewrite that paint line's properties at its live quantity.
     Same variant, same quantity, same _kit, so the price and the rest of the kit are untouched. */
  function attachGuide(){
    var a = S.lastAdd; if (!a || S.busy) return;
    var drawer = document.querySelector('cart-drawer');
    var canDrawer = !!(drawer && typeof drawer.getSectionsToRender === 'function');
    S.busy = true; S.guideFail = false; setMsg('', ''); render();
    getCart().then(function(c){
      var ln = null; (c && c.items || []).forEach(function(i){ if (i.key === a.key) ln = i; });
      /* the line left the cart: fall back to riding on the next add */
      if (!ln) { S.lastAdd = null; return done('', ''); }
      /* keep the line's other properties (e.g. the two-can "Includes" note) */
      var props = {}; Object.keys(ln.properties || {}).forEach(function(k){ props[k] = ln.properties[k]; });
      props._kit = a.kit; props['Printed guide'] = a.guide;
      return post('cart/change.js', { id: a.key, quantity: ln.quantity, properties: props }).then(function(res){
        if (!res.ok || res.j.status) throw new Error('change');
        (res.j.items || []).forEach(function(i){ if (i.variant_id === a.id && i.properties && i.properties._kit === a.kit) a.key = i.key; });
        a.guided = true;
        done('Added to your order \u2014 it ships in the box with your paint.', 'ok');
        if (canDrawer) syncDrawer(drawer, res.j);
      });
    }).catch(function(){ S.guideFail = true; done('Couldn\u2019t add it \u2014 mention it in the order note at checkout.', 'err'); });
  }
  function submit(){
    var L = kbLines(); if (!L.length || S.busy) return;
    var smpAdd = isSample();
    var kit = 'K' + Date.now().toString(36).toUpperCase(), shown = kbTotal(L);
    var pl = null; L.forEach(function(l){ if (l.role === 'paint') pl = l; });
    var gText = isLiquid() ? D.copy.guideGun : D.copy.guideAerosol;
    S.busy = true; setMsg('', ''); render();
    var drawer = document.querySelector('cart-drawer');
    var canDrawer = !!(drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function');
    getCart().then(function(before){
      var over = overCap(L, before); if (over) return done(over, 'err');
      var body = { items: kbPayload(L, kit) };
      if (canDrawer) { body.sections = drawer.getSectionsToRender().map(function(s){ return s.id; }); body.sections_url = window.location.pathname; }
      return post('cart/add.js', body).then(function(res){
        if (!res.ok || res.j.status) {
          var why = res.j.description || res.j.message || 'We couldn\u2019t add your kit.';
          return rollback(kit).then(function(after){
            if (canDrawer) syncDrawer(drawer, after);
            done(why + (after ? ' Nothing from this kit was added \u2014 adjust it and try again.' : ' Part of this kit may already be in your cart. Check your cart before you try again.'), 'err');
          });
        }
        if (before && typeof before.total_price === 'number') D.cartTotal = before.total_price + shown;
        if (!canDrawer || !res.j.sections) { window.location.href = D.cartUrl || '/cart'; return; }
        /* remember this kit's paint line so a printed guide asked for later lands on it */
        S.guideFail = false; S.lastAdd = null;
        if (pl && !smpAdd) (res.j.items || []).forEach(function(i){
          if (i.variant_id === pl.id && i.properties && i.properties._kit === kit) S.lastAdd = { kit: kit, id: pl.id, key: i.key, guide: gText, guided: !!(pl.props && pl.props['Printed guide']) };
        });
        done('Added to your cart.', 'ok');
        drawer.classList.remove('is-empty');
        if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(ui.querySelector('[data-k="add"]') || ui.querySelector('[data-k="h"]') || root);
        try { drawer.renderContents(res.j); } catch (err) { window.location.href = D.cartUrl || '/cart'; }
      });
    }).catch(function(){ done('We couldn\u2019t add your kit. Try again.', 'err'); });
  }

  /* ---------- init ---------- */
  var moved = [];
  function boot(){
    page = document.querySelector('.trpd');
    buyCol = page && page.querySelector('.trpd-buy-col');
    form = page && page.querySelector('#trpd-form');
    pills = page ? page.querySelectorAll('.trpd-size') : [];
    if (!guardsOk()) return false;
    root.setAttribute('data-trkb-init', '1');
    var stale = buyCol.querySelectorAll('[data-trkb-root]');
    for (var i = 0; i < stale.length; i++) { if (stale[i] !== root) stale[i].parentNode.removeChild(stale[i]); }
    ui = document.createElement('div'); ui.className = 'trkb-ui';
    live = document.createElement('div'); live.className = 'trkb-sr'; live.setAttribute('aria-live', 'polite');
    alertBox = document.createElement('div'); alertBox.className = 'trkb-sr'; alertBox.setAttribute('role', 'alert');
    root.appendChild(ui); root.appendChild(live); root.appendChild(alertBox);
    ui.addEventListener('click', onClick); ui.addEventListener('change', onChange);
    /* the shared sample form (rendered by the Liquid inside the root only when the sample product exists): kept detached
       until "Enter your color" is picked; its price / busy changes refresh the buy bar without re-rendering the builder */
    smpEl = SMP ? root.querySelector('tr-sample-request') : null;
    if (smpEl) { smpEl.parentNode.removeChild(smpEl); smpEl.addEventListener('trsr:change', function(){ if (smpCustom()) emitState(); }); }
    var host = root.parentNode, price = page.querySelector('.trpd-price');
    buyCol.insertBefore(root, form);
    /* facts box + proof strip under the price (fallback: top of the buy column); guide link under the builder */
    if (host) {
      var par = price && price.parentNode ? price.parentNode : buyCol, ref = price && price.parentNode ? price.nextSibling : buyCol.firstChild;
      ['[data-trkb-facts]', '[data-trkb-proof]'].forEach(function(sel){ var el = host.querySelector(sel); if (el) { par.insertBefore(el, ref); moved.push(el); } });
      var gl = host.querySelector('[data-trkb-guidelink]'); if (gl) { buyCol.insertBefore(gl, form); moved.push(gl); }
    }
    var start = paintV(activePillId()) || paintV(+((form.querySelector('[name="id"]') || {}).value || 0));
    /* the page always opens on a paint size, never on Sample (S.smp starts false) */
    if (!start || !start.available) { for (var j = 0; j < D.paint.variants.length; j++) { if (D.paint.variants[j].available) { start = D.paint.variants[j]; break; } } }
    setSize(start.id, false);
    applyPrimerDefault();
    render();
    sayMethod();
    document.addEventListener('trkb:guide', onGuide);
    document.addEventListener('trkb:add', onBarAdd);
    root.hidden = false;
    page.classList.add('trkb-on');
    return true;
  }
  if (!boot() && document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:unload', function(e){
    if (!e.detail || e.detail.sectionId !== SID) return;
    if (page) page.classList.remove('trkb-on');
    document.removeEventListener('trkb:guide', onGuide);
    document.removeEventListener('trkb:add', onBarAdd);
    moved.forEach(function(el){ if (el.parentNode) el.parentNode.removeChild(el); });
    if (root.parentNode) root.parentNode.removeChild(root);
  });
})();
